import { Layout } from "lucide-react";
import CustomerDashboard from "./CustomDashboard";
import React from "react";
import LayoutHOC from "../../LayoutHOC";
import { useParams } from "react-router-dom";

function CombinedWrapper() {
  const { leadTypePath: templateId } = useParams();

  return (
    <div className="px-2 h-full">
      <CustomerDashboard propTemplateId={templateId} isCompanyLevel={true} />
    </div>
  );
}

export default LayoutHOC(CombinedWrapper);
